import './Progress.css'

export type ProgressProps = {
  /** Progress from 0 to 1; clamped defensively. */
  value: number
  'aria-label'?: string
}

export function Progress({ value, 'aria-label': ariaLabel = 'Voortgang' }: ProgressProps) {
  const clamped = Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0))
  const percent = Math.round(clamped * 100)
  return (
    <div
      className="ui-progress"
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
    >
      <div className="ui-progress__fill" style={{ width: `${percent}%` }} />
    </div>
  )
}
